export function changeLng(lng) {
  return localStorage.setItem("language", lng)
}